import Select from './select'
import Text from './text'
import File from './file'
import setType from './setType'

export default function createAggregationField(field) {
  const identifier = field.key
  const fn = { select: Select, file: File, text: Text }
  field = setType(field)
  return fn[field.type]({ ...field, identifier, aggregation: true })
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/createAggregationField.js